import React, { useState, useEffect, useCallback } from 'react';
import './orders.css'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button,Modal,ModalHeader } from 'reactstrap';
import Axios from 'axios'
import { MapContainer, TileLayer, Marker, Polyline } from "react-leaflet";



export default function Orders() {
    document.title = "New Order | Easybox - Logistics";
    const [email, setEmail] = useState("");
    const [storeID, setStoreid] = useState('');
    const [storename, setStorename] = useState('')
    const [branchID, setBranchid] = useState('');
    const [deliverylocation, setDeliverylocation] = useState('');
    const [destination, setDestination] = useState('');
    const [isDistance, setIsdistance] = useState(false);
    // const [distance, setDistance] = useState('');
    const [response, setResponse] = useState(null);
    const storeLocation = 'Naivas Westlands'

    const [customerName, setCustomername] = useState('');
    const [customerPhone, setCustomerphone] = useState("")
    const [orderValue, setOrdervalue] = useState('');
    const [deliveryType, setDeliverytype] = useState('');
    const [paymentType, setPaymenttype] = useState('')
    const [instructions, setInstructions] = useState('')
    const [orderID, setOrderid] = useState('')
    const [companies,setCompanies] = useState([])
    const [landmark, setlandmark] = useState('');
    const [defaultRate, setDefaultrate] = useState('')
    const [additionalRate, setAdditionalrate] = useState('');

    const [modal, setModal] = useState(false)
    const [entriesState, setEntriesstae] = useState(false)

    const [preview, setPreview] = useState(false);
    const [entries, setEntries] = useState([
        { itemName: "", quantity: "", amount: "" },
    ]);

    const [submitText, setSubmittext] = useState('Submit order');
    const [allocationChoice, setAllocationchoice] = useState();
    const [selectedCompany, setSelectedcompany] = useState("")
    const [charges, setCharges] = useState('')
    const [predefinedLocationB, setPredefinedLocationB] = useState(null);


    // Handle change for radio button selection
    const handleAllocation = (event) => {
      setAllocationchoice(event.target.value === 'true');
    };



  //Fetch user email
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setStoreid(data.store_id)
        setBranchid(data.branch_id)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])

  useEffect(()=>{
    const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getStoredetails?storeid=${storeID}`)
        const data = await res.json();

        setStorename(data.store_name)
      }
      catch(err){}
    }

    if(storeID){
      fetchData();
    }

  },[storeID])

//get attached stores
useEffect(()=>{
    const fetchData = async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAttachedcompanies?store=${storeID}`)
        const data = await res.json();
        setCompanies(data)
    }

    if(storeID){
        fetchData();
    }
},[storeID])

useEffect(() => {
    const fetchBranchDetails = async () => {
      try {
        const response = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getBranchdetails?branch=${branchID}`); // Replace '1' with the desired branch ID
        const data = await response.json();

        if (data.pinLocation) {
          const [lat, lng] = data.pinLocation.split(",").map(Number); // Split and convert to numbers
          setPredefinedLocationB({ lat, lng }); // Set state in desired format
        }
      } catch (error) {
        console.error("Error fetching branch details:", error);
      }
    };
    if(branchID){
        fetchBranchDetails();
    }
    
  }, [branchID]);



useEffect(()=>{
    const allocate =async()=>{
        const allocateCompany = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAvailablecompanies?store=${storeID}`);
        const companiesData = await allocateCompany.json();
        setSelectedcompany(companiesData.uniqueID)

    }

    if(allocationChoice ==true){
        allocate();
    }
},[allocationChoice])

useEffect(()=>{
    const fetchDefault =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getDefaultrate?company=${selectedCompany}`);
        const data = await res.json();
        setDefaultrate(data.defaultAmount);

        


    }
    const fetchAdditional =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAdditionalrate?company=${selectedCompany}`);
        const data = await res.json();
        setAdditionalrate(data.additionalAmount)
    }

    if(selectedCompany){
        fetchDefault();
        fetchAdditional();
       
            

        

        
    }


},[selectedCompany])

const notification=()=>{
  const formattedPhone = customerPhone.replace(/^0/, '254');

  const message = `Hi ${customerName}, your order #${orderID} at ${storename} is ready for delivery. We will notify you once en route.\n Thank you for trusting in us. \n Happy Holidays!`
  Axios.post('https://n8n.uidevlabs.com/webhook/3ec029de-456b-4c1e-87a1-a68c05e617db',{phone:formattedPhone,message}).then((res)=>{
    toast.success('Notification sent')
  }).catch((err)=>{
    toast.error('Error happened')
  })
}

useEffect(()=>{
    if(defaultRate && additionalRate){
        if(parseInt(distance)  < 10.5){
            setCharges(defaultRate)
        }
        else{
            const additinal = (parseFloat(distance) - 10)
            const addAmount = additionalRate*additinal
            const am = parseFloat(defaultRate)+addAmount
            setCharges(Math.round(am));
        }
    }
},[defaultRate,additionalRate])




    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedEntries = [...entries];
        updatedEntries[index][name] = value;
        setEntries(updatedEntries);
    };
    const handleAddEntry = () => {
        setEntries([
            ...entries,
            { itemName: "", quantity: "", amount: "" },
        ]);
    };

    const removeEntry = (index) => {
        // Create a new array with the entry at the given index removed
        const updatedEntries = entries.filter((_, i) => i !== index);
        setEntries(updatedEntries);
      };
    const handleSubmit = async () => {

        try {
            const response = await Axios.post('https://easyboxstoresapi.uuidesign.xyz/api/submitItems', { orderId: orderID, entries });
           
        } catch (error) {
    
            
        }
    };

    const toggle=()=>{
        setEntriesstae(true)
        setModal(!modal)
    }


    const generateRandomString = (length) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      };

    useEffect(()=>{
        const randomStr = generateRandomString(6);
        setOrderid(`RD-${randomStr}`)
    },[])

   
    const onPreview=()=>{
    

        fetchRoute();
        setPreview(true)
    }
    const closeModule=()=>{
        setModal(!modal)
    }

    const submitOrder =async()=>{
        if(orderID !== '' && customerPhone !== '' && customerName !== '' && orderValue !== '' && paymentType !== '' && deliveryType !== '' && searchQuery && landmark !== ''){
            setSubmittext('Loading...')
           

            const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/createOrder',{
                method : 'POST',
                headers:{
                    'Content-Type':'application/json'
                },
                body:JSON.stringify({
                    orderID,storeID,branchID,email,customerName,customerPhone,orderValue,searchQuery,deliveryType,paymentType,instructions,selectedCompany,distance,formattedCoordinates,charges,landmark,predefinedLocationB
                }),
                credentials:'include'
            })

            const data = await res.json();
            const { success } = data;

            if(success == true){
                const randomStr = generateRandomString(6);
                handleSubmit();
                toast.success(`Order ${orderID} submitted successfully to ${selectedCompany}`)
                // notification()
                setCustomername('')
                setOrderid(`RD-${randomStr}`)
                setCustomerphone('')
                setOrdervalue('')
                setDeliverylocation('')
                setInstructions('')
                setEntries([
                    { itemName: "", quantity: "", amount: "" },
                ])
                setSubmittext('Submit order')
                setPreview(false)
            }
            if(success == false){
                toast.error('Something went wrong. Try again!')
                setSubmittext('Submit order')
            }
        }
        else{
            toast.error('All fields marked * are required!')
        }
        
        
    }


    const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [deliveryLocation, setDeliveryLocation] = useState(null);
  const [route, setRoute] = useState([]);
  const [formattedCoordinates, setFormattedCoordinates] = useState(""); // To store formatted lat, long
  const [distance, setDistance] = useState(""); // To store the distance
 

  // Fetch suggestions
  const fetchSuggestions = async (query) => {
    if (!query) {
      setSuggestions([]);
      return;
    }
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1&limit=5`
    );
    const data = await response.json();
    setSuggestions(data);
  };

  // Haversine formula to calculate the distance
  const calculateDistance = (location1, location2) => {
    const toRad = (value) => (value * Math.PI) / 180; // Convert degrees to radians

    const R = 6371; // Radius of Earth in km
    const dLat = toRad(location2.lat - location1.lat);
    const dLng = toRad(location2.lng - location1.lng);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(location1.lat)) *
        Math.cos(toRad(location2.lat)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in km
  };

  // Handle suggestion click
  const handleSuggestionClick = (suggestion) => {
    const location = {
      lat: parseFloat(suggestion.lat),
      lng: parseFloat(suggestion.lon),
    };

    // Format coordinates as 0000,0000
    const formatted = `${location.lat.toFixed(4)},${location.lng.toFixed(4)}`;
    const calculatedDistance = calculateDistance(location, predefinedLocationB).toFixed(2); // Calculate distance

    setSearchQuery(suggestion.display_name); // Update the input field
    setSelectedLocation(location);
    setFormattedCoordinates(formatted); // Update formatted coordinates
    setDistance(`${calculatedDistance}`); // Update the distance state
    setSuggestions([]); // Clear suggestions
  };

  // Fetch route from OSRM
  const fetchRoute = async () => {
    if (!selectedLocation) {
      alert("Please select a location first!");
      return;
    }
    const response = await fetch(
      `http://router.project-osrm.org/route/v1/driving/${selectedLocation.lng},${selectedLocation.lat};${predefinedLocationB.lng},${predefinedLocationB.lat}?overview=full&geometries=geojson`
    );
    const data = await response.json();

    if (data.routes.length > 0) {
      const coordinates = data.routes[0].geometry.coordinates.map(([lng, lat]) => ({
        lat,
        lng,
      }));
      setRoute(coordinates);
      setDeliveryLocation(selectedLocation); // Set the selected location for the marker
    } else {
      alert("Route not found!");
    }
  };
  
  

  return (
    <div className='ordersContainer'>
        <Breadcrumbs title="Easybox" breadcrumbItem="New Order" />
            <ToastContainer />
        <div className="containerTabs">

     
        <div className="neworderLeft">
           <p>Fill the fields below</p>

         
           <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Customer name *" onChange={(e)=>{setCustomername(e.target.value)}}>
              <Form.Control  className='inputSearch' value={customerName}  type="text" placeholder="Customer name" />
           </FloatingLabel>
           <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Customer phone * e.g 0712345678" onChange={(e)=>{setCustomerphone(e.target.value)}}>
              <Form.Control  className='inputSearch' value={customerPhone}  type="text" placeholder="Customer phone  " />
           </FloatingLabel>
           <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Order value *" onChange={(e)=>{setOrdervalue(e.target.value)}}>
              <Form.Control  className='inputSearch' value={orderValue}  type="text" placeholder="Order value" />
           </FloatingLabel>
           <div style={{ position: "relative", marginBottom: "20px" }}>
                <input
                type="text"
                value={searchQuery}
                onChange={(e) => {
                    setSearchQuery(e.target.value);
                    fetchSuggestions(e.target.value);
                }}
                placeholder="Delivery location"
               className='locationInput'

                />
                <div
                style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    background: "white",
                    border: "1px solid #ddd",
                    zIndex: 1000,
                    width: "100%",
                    maxHeight: "150px",
                    overflowY: "auto",
                }}
                >
                {suggestions.map((suggestion, index) => (
                    <div
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}
                    style={{
                        cursor: "pointer",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                    }}
                    >
                    {suggestion.display_name}
                    </div>
                ))}
                </div>
            </div>
           
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Landmark *" onChange={(e)=>{setlandmark(e.target.value)}}>
              <Form.Control  className='inputSearch' value={landmark}  type="text" placeholder="Landmark" />
           </FloatingLabel>    
           
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Delivery type *" onChange={(e)=>{setDeliverytype(e.target.value)}} >
                    <Form.Select className="selectMeter"  aria-label="Floating label select example" >
                        <option selected disabled>Delivery type</option>
                        <option value='Normal delivery'>Normal delivery</option>
                        <option value='Bulk delivery'>Bulk delivery</option>                                                 
                    </Form.Select>
                    
            </FloatingLabel>
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Delivery Payment Type *" onChange={(e)=>{setPaymenttype(e.target.value)}}  >
                    <Form.Select className="selectMeter"  aria-label="Floating label select example" >
                        <option selected disabled>Delivery Payment Type</option>
                        <option value='Prepaid'>Prepaid</option>
                        <option value='On Delivery'>On Delivery</option>                                                 
                    </Form.Select>
                    
            </FloatingLabel>
            <FloatingLabel className='formInput' controlId="floatingTextareaGrid" label="Instructions" onChange={(e)=>{setInstructions(e.target.value)}}>
                    <Form.Control
                        as="textarea"
                        className='inputSearch'
                        placeholder="Instructions naration"
                        value={instructions}
                        style={{ height: '100px' }}
                    />
                </FloatingLabel>
            <p onClick={toggle} className='addItems'>Add purchase items</p>
            <Button className='previewButton' color='info' onClick={onPreview}>Preview</Button>


            <div>
      {/* Input Field and Suggestions */}


      {/* Display Formatted Coordinates */}
      {/* {formattedCoordinates && (
        <div style={{ marginBottom: "20px", fontSize: "16px", color: "green" }}>
          Selected Coordinates: {formattedCoordinates}
        </div>
      )}
      {distance && (
        <div style={{ marginBottom: "20px", fontSize: "16px", color: "blue" }}>
          Distance to Location B: {distance}
        </div>
      )} */}

      
    </div>
   
        </div>
        <div className="neworderRight">
            
        <div className="entryMap">
                <div>
                {!predefinedLocationB &&
                    <p>LOADING YOUR LOCATION...</p>
                }
                {predefinedLocationB &&
                <>
                <MapContainer center={predefinedLocationB} zoom={13} style={{ height: "400px", width: "100%" }}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    {/* Marker for Predefined Location B */}
                    <Marker position={predefinedLocationB} />
                    {/* Marker for Selected Delivery Location */}
                    {deliveryLocation && <Marker position={deliveryLocation} />}
                    {/* Route */}
                    {route.length > 0 && <Polyline positions={route} color="blue" />}
                </MapContainer>
                <p>Distance: {distance} km</p>
                </>
                
                }
               
               
                </div>
            </div>
            <h5 className='previewTitle'>Order preview</h5>
            {preview &&
                <>
                    <p><strong>Order#</strong>: {orderID}</p>
                    <p><strong>Client</strong>: {customerName}</p>
                    <p><strong>Contacts</strong>: {customerPhone}</p>
                    <p><strong>Order value</strong>: {orderValue}</p>
                    <p><strong>Destination</strong>: {searchQuery}</p>
                    <p><strong>Delivery type</strong>: {deliveryType}</p>
                    <p><strong>Payment type</strong>: {paymentType}</p>
                    <p><strong>Instructions</strong>: {instructions}</p>

                   

                    
                    <>
                    <p><strong>Purchase Items</strong></p>
                    {entries.map((val,index)=>{
                        return(
                            <div key={index} className='entryList'>
                                <p>{val.quantity}</p>
                                <p>{val.itemName}</p>
                                <button className='removeButton' onClick={() => removeEntry(index)}> remove </button>
                            </div>
                        )
                    })}
                    </>
                    
                  

                   
                    

                    <h4 className='cost'>Cost: {charges} Kes</h4>
                   
                    <Button className='previewButton2' color='primary' onClick={submitOrder}>{submitText}</Button>

                </>
            
            }
            {!preview &&
            <>
                <p>Please enter an order for preview</p>
              
            </>   
            }
        </div>     

      </div>

         {/* input purchase items */}
      <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader>Add purchase items</ModalHeader>
              <div className='modalContainer'>
               
               
                 
              {entries.map((entry, index) => (
            <div key={index} className='entryFields2'>
            <FloatingLabel
              id='iField'
              className="formInput"
              controlId={`itemName-${index}`}
              label={`Item Name ${index + 1}`}
            >
              <Form.Control
                name="itemName"
                onChange={(event) => handleInputChange(index, event)}
                value={entry.itemName}
                className="inputSearch"
                type="text"
                placeholder={`Item Name ${index + 1}`}
              />
            </FloatingLabel>

            <FloatingLabel
              id='iField'
              className="formInput"
              controlId={`quantity-${index}`}
              label={`Quantity ${index + 1}`}
            >
              <Form.Control
                name="quantity"
                onChange={(event) => handleInputChange(index, event)}
                value={entry.quantity}
                className="inputSearch"
                type="number"
                placeholder={`Quantity ${index + 1}`}
              />
            </FloatingLabel>

            <FloatingLabel
              className="formInput"
              controlId={`amount-${index}`}
              label={`Amount ${index + 1}`}
            >
              <Form.Control
                name="amount"
                onChange={(event) => handleInputChange(index, event)}
                value={entry.amount}
                className="inputSearch"
                type="number"
                placeholder={`Amount ${index + 1}`}
              />
            </FloatingLabel>
          </div>
        ))}

                  <div className='itemsButton'>
                    <Button color='warning' className='addButton'  onClick={handleAddEntry}>Add item</Button>
                    <Button onClick={closeModule} color='success' className='addButton'>Submit</Button>

                  </div>

                 
               
              </div>
            </Modal>
    </div>
  )
}
